module.exports = __webpack_public_path__ + "img/com-img-5.acba6e2e.png";